<app-dialog
  heading="Configurar as opções do módulo"
  closeLabel="Fechar configurações do módulo"
  (closed)="closed.emit()"
>
  <form class="flex flex-col gap-5" [formGroup]="formConfigModule">
    <div class="w-full flex flex-col md:flex-row gap-5">
      <div class="form-group">
        <label class="font-bold text-sm">Nome do módulo:</label>
        <input type="text" class="form-input" placeholder="Nome" formControlName="name" [disabled]="true" />
      </div>
    </div>

    <ng-container *ngFor="let field of configSchemaArray">
      <ng-container *ngIf="getControl(field.key) as control">
        <div class="form-group">
          <label class="font-bold text-sm">{{ field.value.description }}</label>

          <input
            *ngIf="field.value.type === 'string' && field.value.optionsType !== 'npsSurvey'"
            type="text"
            class="form-input"
            placeholder="{{ field.value.description }}"
            [formControl]="control"
          />

          <input
            *ngIf="isNumericType(field.value.type)"
            type="number"
            min="0"
            class="form-input"
            placeholder="Ex: 30 (dias)"
            [formControl]="control"
          />

          <input
            *ngIf="isUnknownType(field.value.type)"
            type="text"
            class="form-input"
            placeholder="{{ field.value.description }}"
            [formControl]="control"
          />

          <ng-select
            *ngIf="field.value.type === 'string' && field.value.optionsType === 'npsSurvey'"
            notFoundText="Nenhuma pesquisa encontrada"
            [searchable]="true"
            [formControl]="control"
          >
            <ng-option *ngFor="let survey of npsSurveys" [value]="survey.id">
              {{ survey.name }}{{ survey.companyId === null ? ' (Padrão do sistema)' : ''
              }}{{ survey.status !== 1 ? ' (Inativa)' : '' }}
            </ng-option>
          </ng-select>

          <div
            *ngIf="field.value.type === 'string' && field.value.optionsType === 'npsSurvey' && !companyId"
            class="text-xs text-red-500 py-2"
          >
            Defina a empresa do setup para carregar as pesquisas NPS.
          </div>

          <div
            *ngIf="
              field.value.type === 'string' &&
              field.value.optionsType === 'npsSurvey' &&
              companyId &&
              !npsSurveys.length
            "
            class="text-xs text-gray-400 py-2"
          >
            Nenhuma pesquisa NPS disponível.
          </div>

          <div
            *ngIf="
              field.value.type === 'string' &&
              field.value.optionsType === 'npsSurvey' &&
              companyId &&
              npsSurveys.length &&
              !control.value
            "
            class="text-xs text-yellow-600 py-2"
          >
            Selecione uma Pesquisa NPS para o módulo Finish funcionar corretamente.
          </div>

          <ng-select
            *ngIf="field.value.type === 'bool'"
            notFoundText="Nenhum item encontrado"
            [searchable]="false"
            [formControl]="control"
          >
            <ng-option [value]="true">Sim</ng-option>
            <ng-option [value]="false">Não</ng-option>
          </ng-select>

          <div *ngIf="field.value.type === 'array' && field.value.optionsType === 'modules'">
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              <div
                *ngFor="let module of modules"
                class="p-3 bg-white border rounded-lg shadow-sm hover:shadow-md transition-all duration-150 cursor-pointer"
                [class.border-blue-400]="control.value?.includes(module.route)"
                [class.bg-blue-50]="control.value?.includes(module.route)"
              >
                <label class="flex items-center justify-between gap-3 cursor-pointer">
                  <span class="text-sm font-medium text-chathams-blue break-words">{{ module.name }}</span>
                  <input
                    type="checkbox"
                    [checked]="control.value?.includes(module.route)"
                    (change)="onModuleCheckboxChange($event, field.key, module.route)"
                    class="w-5 h-5 rounded border-gray-300 focus:ring-2 focus:ring-offset-1 focus:ring-cerise-red"
                  />
                </label>
                <div
                  *ngIf="
                    control.value?.includes(module.route) &&
                    getControl('enabledPaths') &&
                    module.route !== 'Module_SkinCare'
                  "
                  class="mt-2 pt-2 border-t border-gray-200"
                >
                  <label class="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      [checked]="isModuleEnabledPath(module.route)"
                      (change)="toggleModuleEnabledPath(module.route, $any($event.target).checked)"
                      class="w-4 h-4 rounded border-gray-300 focus:ring-2 focus:ring-cerise-red"
                    />
                    <span class="text-xs text-gray-500 font-medium">Atendimento de Saúde</span>
                  </label>
                  <label *ngIf="isModuleEnabledPath(module.route)" class="flex items-center gap-2 cursor-pointer mt-2">
                    <input
                      type="checkbox"
                      [checked]="isModuleShowAsCard(module.route)"
                      (change)="toggleModuleShowAsCard(module.route, $any($event.target).checked)"
                      class="w-4 h-4 rounded border-gray-300 focus:ring-2 focus:ring-cerise-red"
                    />
                    <span class="text-xs text-gray-500 font-medium">Exibir também como card no Intro</span>
                  </label>
                </div>
              </div>
            </div>

            <div *ngIf="getControl('enabledPaths') && enabledPathsOrdered.length > 0" class="mt-4">
              <h4 class="text-sm font-bold text-gray-600 mb-2">
                Ordem de Atendimento de Saúde (arraste para reordenar)
              </h4>
              <div
                class="border rounded-lg p-2 bg-gray-50"
                cdkDropList
                [cdkDropListData]="enabledPathsOrdered"
                (cdkDropListDropped)="dropEnabledPaths($event)"
              >
                <div
                  *ngFor="let path of enabledPathsOrdered; let i = index"
                  cdkDrag
                  class="flex items-center gap-2 p-2 mb-1 bg-white rounded shadow-sm border cursor-move"
                >
                  <mat-icon class="text-gray-400 text-base">drag_indicator</mat-icon>
                  <span class="text-sm font-bold text-gray-400">{{ i + 1 }}.</span>
                  <span class="text-sm font-medium text-chathams-blue">{{ path.name }}</span>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="field.value.type === 'array' && field.value.optionsType?.includes('paths')">
            <div class="mb-4">
              <h4 class="text-sm font-bold text-gray-600 mb-2">Caminhos Selecionados (arraste para reordenar)</h4>
              <div
                class="border rounded-lg p-2 min-h-[60px] bg-gray-50"
                cdkDropList
                [cdkDropListData]="control.value || []"
                (cdkDropListDropped)="dropPaths($event, field.key)"
              >
                <div
                  *ngFor="let selectedPath of control.value || []; let i = index"
                  class="flex items-center p-2 mb-1 bg-white rounded shadow-sm border"
                  cdkDrag
                >
                  <mat-icon class="cursor-move text-gray-400 mr-2">drag_indicator</mat-icon>

                  <span class="text-sm font-medium text-chathams-blue">
                    <span class="font-bold">{{ i + 1 }}.</span> {{ getPathName(selectedPath.key) }}
                  </span>

                  <button
                    type="button"
                    (click)="onPathCheckboxChange({ target: { checked: false } }, field.key, selectedPath.key)"
                  >
                    Remover
                  </button>
                </div>

                <div *ngIf="!control.value?.length" class="text-center text-xs text-gray-400 py-4">
                  Nenhum caminho selecionado.
                </div>
              </div>
            </div>

            <div>
              <h4 class="text-sm font-bold text-gray-600 mb-2">Caminhos Disponíveis</h4>
              <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                <ng-container *ngFor="let path of paths">
                  <div
                    *ngIf="!isPathSelected(field.key, path.key)"
                    class="p-3 bg-white border rounded-lg shadow-sm hover:shadow-md transition-shadow"
                  >
                    <label class="flex items-center justify-between gap-3 cursor-pointer">
                      <span class="text-sm font-medium text-chathams-blue break-words">{{ path.name }}</span>
                      <input
                        type="checkbox"
                        [checked]="false"
                        (change)="onPathCheckboxChange($event, field.key, path.key)"
                        class="w-5 h-5 rounded border-gray-300"
                      />
                    </label>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <div *ngIf="field.value.type === 'array' && field.value.optionsType === 'customQuestionnaire'">
            <div class="mb-4">
              <h4 class="text-sm font-bold text-gray-600 mb-2">Questionários Selecionados (arraste para reordenar)</h4>
              <div
                class="border rounded-lg p-2 min-h-[60px] bg-gray-50"
                cdkDropList
                [cdkDropListData]="control.value || []"
                (cdkDropListDropped)="dropPaths($event, field.key)"
              >
                <div
                  *ngFor="let selectedQuestionnaire of control.value || []; let i = index"
                  class="flex items-center p-2 mb-1 bg-white rounded shadow-sm border"
                  cdkDrag
                >
                  <mat-icon class="cursor-move text-gray-400 mr-2">drag_indicator</mat-icon>

                  <span class="text-sm font-medium text-chathams-blue">
                    <span class="font-bold">{{ i + 1 }}.</span> {{ getQuestionnaireName(selectedQuestionnaire.id) }}
                  </span>

                  <button
                    type="button"
                    (click)="
                      onQuestionnaireCheckboxChange({ target: { checked: false } }, field.key, selectedQuestionnaire.id)
                    "
                  >
                    Remover
                  </button>
                </div>

                <div *ngIf="!control.value?.length" class="text-center text-xs text-gray-400 py-4">
                  Nenhum questionário selecionado.
                </div>
              </div>
            </div>

            <div>
              <h4 class="text-sm font-bold text-gray-600 mb-2">Questionários Disponíveis</h4>

              <div *ngIf="!companyId" class="text-xs text-red-500 py-2">
                Defina a empresa do setup para carregar os questionários personalizados.
              </div>

              <div *ngIf="companyId && !customQuestionnaires.length" class="text-xs text-gray-400 py-2">
                Nenhum questionário personalizado disponível.
              </div>

              <div
                *ngIf="companyId && customQuestionnaires.length"
                class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3"
              >
                <ng-container *ngFor="let questionnaire of customQuestionnaires">
                  <div
                    *ngIf="!isQuestionnaireSelected(field.key, questionnaire.id)"
                    class="p-3 bg-white border rounded-lg shadow-sm hover:shadow-md transition-shadow"
                  >
                    <label class="flex items-center justify-between gap-3 cursor-pointer">
                      <span class="text-sm font-medium text-chathams-blue break-words">{{ questionnaire.name }}</span>
                      <input
                        type="checkbox"
                        [checked]="false"
                        (change)="onQuestionnaireCheckboxChange($event, field.key, questionnaire.id)"
                        class="w-5 h-5 rounded border-gray-300"
                      />
                    </label>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="form-group flex items-center justify-center">
      <button
        type="button"
        *isAllowed="[ERoleAdminString.Admin, 'setup.create']"
        class="w-80 h-9 btn btn--secondary"
        (click)="saveModuleSettings()"
      >
        + Salvar configurações do módulo
      </button>
    </div>
  </form>
</app-dialog>
